module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV4AAAACCAYAAAAQELQiAAAAMUlEQVRIS+3QQQ0AQAgEMZBxBhG7QdS54NUxMEk7yZQIECBA4Eygd/ed3YwIECBAoD71vwVE4f6xewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle Copy 2.png
// module id = rA5S
// module chunks = 14